import React from "react";
import { Img } from "../../design-system/Img";
import DeviceListItem from "./DeviceListItem";
import { Handler } from "./Handler";
import { deviceType } from "../../utils/types";
import { useNavigate } from "react-router-dom";

interface propType {
  showModal: boolean;
  toggleDeviceList: () => void;
  navigateToApproveModal: (device: deviceType) => void;
  from?: string;
  registrations: deviceType[];
}

const SelectDevice: React.FC<propType> = (props) => {
  const { showModal, toggleDeviceList, navigateToApproveModal } = props;
  const { registrations }: { registrations: deviceType[] } = Handler(props);
  const navigate = useNavigate();
  const onclose = () => {
    if (props.from) {
      localStorage.setItem("user", "null");
      navigate("/auth/login");
    } else {
      toggleDeviceList();
    }
  };
  if (!showModal) return null;
  return (
    <>
      <div
        className="justify-center items-center flex overflow-x-hidden 
      fixed inset-0 z-50 outline-none focus:outline-none"
      >
        <div className="relative w-auto my-6 mx-auto max-w-3xl ">
          {/*content*/}
          <div
            className="border-0 rounded-xl shadow-lg relative flex flex-col w-full bg-white-A700 outline-none 
          focus:outline-none  overflow-hidden"
          >
            {/*header*/}
            <div className="flex flex-row items-center justify-between p-5 bg-accountHeader rounded-t">
              <p className="text-[20px] font-semibold  text-white-A700 m-0">
                Choose a device for approval
              </p>

              <Img
                className="hover:cursor-pointer"
                src={"x-close.svg"}
                alt="close"
                onClick={onclose}
              />
            </div>
            {/*body*/}
            <div className="flex flex-col relative px-5 py-4 flex-auto h-[500px] overflow-y-scroll gap-5 no-scrollbar">
              {registrations.length > 0 ? (
                registrations.map((device, index) => (
                  <DeviceListItem
                    key={device.id}
                    device={device}
                    handleApprove={navigateToApproveModal}
                  />
                ))
              ) : (
                <div className="flex flex-col items-center justify-center">
                  <p className="text-black text-center font-semibold text-lg">
                    No devices found
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="opacity-25 fixed inset-0 z-40 bg-black-800" />
    </>
  );
};

export default SelectDevice;
